// The one-time code the identity provider round trip leaves in the URL fragment.
export const readSsoCode = (hash) => new URLSearchParams((hash || '').replace(/^#/, '')).get('code') || '';

export const SSO_VERIFIER_KEY = 'qflow:sso:verifier';
export async function createBrowserChallenge() {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const encode = (data) => btoa(String.fromCharCode(...data)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const verifier = encode(bytes);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  sessionStorage.setItem(SSO_VERIFIER_KEY, verifier);
  return encode(new Uint8Array(digest));
}
